import { extractApiError, type HttpApiClient } from "@vana/core";
import { type AmbassadorDelivery, type TeamAmbassador } from "../../domain/entities/team";
import { GetTeamError, ListDeliveriesError } from "../../domain/errors/errors";
import { type TeamRepository } from "../../domain/repos/team-repo";
import {
  type DeliveriesResponse,
  type SummaryResponse,
} from "../../infrastructure/responses/team-responses";

export class TeamRepo implements TeamRepository {
  constructor(private readonly apiClient: HttpApiClient) {}

  async getTeam(supervisorId: string, businessDate: string): Promise<TeamAmbassador[]> {
    try {
      const query = `?supervisor_id=${encodeURIComponent(supervisorId)}&business_date=${encodeURIComponent(businessDate)}`;
      const response = await this.apiClient.get<SummaryResponse>(`v1/supervisor/summary${query}`);
      return response.data?.ambassadors ?? [];
    } catch (error) {
      const { message, apiError } = extractApiError(error);
      throw new GetTeamError(message, apiError);
    }
  }

  async listDeliveries(ambassadorId: string, from: string, to: string): Promise<AmbassadorDelivery[]> {
    try {
      const query = `?assigned_ambassador_id=${encodeURIComponent(ambassadorId)}&delivery_slot_from=${encodeURIComponent(from)}&delivery_slot_to=${encodeURIComponent(to)}`;
      const response = await this.apiClient.get<DeliveriesResponse>(`v1/requests${query}`);
      return response.data?.items ?? [];
    } catch (error) {
      const { message, apiError } = extractApiError(error);
      throw new ListDeliveriesError(message, apiError);
    }
  }
}
